(() => {
  const getCountParts = (value) => {
    const original = value.trim();
    const match = original.match(/(\d[\d,\.]*)/);
    if (!match) return null;

    const numericText = match[1];
    const target = Number(numericText.replace(/,/g, ''));
    if (!Number.isFinite(target)) return null;

    return {
      decimals: numericText.includes('.') ? numericText.split('.')[1].length : 0,
      original,
      prefix: original.slice(0, match.index),
      suffix: original.slice(match.index + numericText.length),
      target,
    };
  };

  const formatCount = (parts, value) => {
    const count = parts.decimals ? value.toFixed(parts.decimals) : Math.round(value).toLocaleString();
    return `${parts.prefix}${count}${parts.suffix}`;
  };

  const initAgencyStatsCountUp = (root = document) => {
    const numbers = root.querySelectorAll('.shopify-agency-stats-banner__number[data-count-up]:not([data-count-ready])');
    if (!numbers.length) return;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      numbers.forEach((number) => {
        number.dataset.countOriginal = number.textContent.trim();
        number.dataset.countReady = 'true';
      });
      return;
    }

    const animateNumber = (el) => {
      if (el.dataset.countAnimated === 'true') return;

      const parts = getCountParts(el.dataset.countOriginal || el.textContent);
      if (!parts) return;

      const duration = Math.min(6200, Math.max(3200, parts.target * 10));
      const startDelay = 450;

      el.dataset.countAnimated = 'true';
      el.textContent = formatCount(parts, 0);

      const tick = (startTime, now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);

        el.textContent = formatCount(parts, parts.target * eased);

        if (progress < 1) {
          requestAnimationFrame((nextNow) => tick(startTime, nextNow));
        } else {
          el.textContent = parts.original;
        }
      };

      window.setTimeout(() => {
        const startTime = performance.now();
        requestAnimationFrame((now) => tick(startTime, now));
      }, startDelay);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        animateNumber(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.45 });

    numbers.forEach((number) => {
      const parts = getCountParts(number.textContent);
      if (parts) {
        number.dataset.countOriginal = parts.original;
        number.textContent = formatCount(parts, 0);
      }

      number.dataset.countReady = 'true';
      observer.observe(number);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initAgencyStatsCountUp());
  document.addEventListener('shopify:section:load', (event) => initAgencyStatsCountUp(event.target));
  initAgencyStatsCountUp();
})();
